import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'antd';

const WorkExpButton = ({ state, onButtonClicked, disabled, loading }) => {
  return (
    <div className="new-mcq-work-exp-btn-wrapper">
      {state && (<Button loading={loading} disabled={disabled} onClick={onButtonClicked && onButtonClicked} className="new-mcq-work-exp-btn" type="primary">{state} <Icon className="btn-icon" type="arrow-right"/></Button>)}
    </div>
  );
};

WorkExpButton.propTypes = {
  state: PropTypes.string,
  onButtonClicked: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool
};

export default WorkExpButton;
